// extracted by mini-css-extract-plugin
export default {"alert":"useSnackbar_alert__dqVsZ","closeButton":"useSnackbar_closeButton__OUks1"};